export const homeTranslations = {
  // Language labels
  lang_english: 'English',
  lang_spanish: 'Español',
  // Not Found
  notfound_title: 'Esta página no ha sido generada',
  notfound_desc: 'Cuéntame más sobre esta página para poder generarla.',

  // Nav
  nav_home: 'Inicio',
  nav_services: 'Servicios',
  nav_gallery: 'Galería',
  nav_areas: 'Áreas de Servicio',
  nav_reviews: 'Reseñas',
  nav_contact: 'Contacto',
  nav_cta: 'Solicitar Cotización',

  // Hero
  hero_tag: 'SERVICIO PROFESIONAL',
  hero_title: 'Limpieza de Casa',
  hero_subtitle: 'Experimenta un hogar impecable con nuestros servicios de limpieza residencial adaptados a tus necesidades.',
  hero_cta_primary: 'Cotización Gratis',
  hero_cta_secondary: 'Ver Servicios',

  // Services
  services_label: 'NUESTROS SERVICIOS',
  services_title: 'Soluciones Premium de Limpieza para Cada Espacio',
  services_learn_more: 'Saber Más',

  // Slides
  slide_2_tag: 'EXPERTOS DE CONFIANZA',
  slide_2_title: 'Limpieza de Apartamento',
  slide_2_subtitle: 'Los espacios compactos merecen grandes resultados. Nuestra limpieza de apartamentos brinda perfección en cada rincón.',
  slide_3_tag: 'GRADO COMERCIAL',
  slide_3_title: 'Limpieza de Oficina',
  slide_3_subtitle: 'Mantén tu espacio de trabajo impecable y productivo con nuestras soluciones de limpieza comercial confiables.',
  slide_4_tag: 'LIMPIEZA ESPECIALIZADA',
  slide_4_title: 'Limpieza Post-Construcción',
  slide_4_subtitle: 'Transforma sitios de construcción polvorientos en espacios listos para habitar con nuestros equipos especializados.',
  slide_5_tag: 'MUDANZA FÁCIL',
  slide_5_title: 'Limpieza de Entrada / Salida',
  slide_5_subtitle: 'Comienza fresco en tu nuevo espacio o deja tu antiguo inmaculado con nuestros servicios de limpieza para mudanzas.',

  // About
  about_label: 'SOBRE NOSOTROS',
  about_title: 'Por Qué Familias y Empresas Confían en Nosotros',
  about_description:
    'Ofrecemos limpieza residencial, de apartamentos, oficinas y post-construcción con un equipo capacitado y horarios flexibles. Elige contratos puntuales o recurrentes — nos adaptamos a tus necesidades.',

  // Service Areas
  areas_label: 'DÓNDE TRABAJAMOS',
  areas_title: 'Áreas Que Atendemos con Orgullo',
  areas_note:
    '¿No estás seguro de si cubrimos tu zona? Escríbenos y con gusto te ayudamos.',
  areas_no_data: 'No hay áreas de servicio disponibles',
  areas_add_hint: 'Las áreas de servicio aparecerán aquí una vez agregadas.',

  // Gallery
  gallery_label: 'NUESTRO TRABAJO',
  gallery_title: 'Galería Antes y Después',
  gallery_upload: 'Subir / Cambiar Imagen',
  gallery_no_data: 'Aún no hay imágenes',
  gallery_add_hint: 'Las imágenes aparecerán aquí una vez agregadas.',

  // Facebook
  facebook_label: 'SOCIAL',
  facebook_title: 'Síguenos en Facebook',
  facebook_placeholder_title: 'Feed de Facebook',
  facebook_placeholder_desc:
    'La integración del feed de Facebook se conectará desde la configuración de administración.',
  facebook_follow: 'Seguir en Facebook',

  // Reviews
  reviews_label: 'TESTIMONIOS',
  reviews_title: 'Lo Que Dicen Nuestros Clientes',

  // Contact
  contact_label: 'CONTACTO',
  contact_title: 'Solicitar Cotización Gratis',
  contact_subtitle: 'Completa el formulario y te contactaremos en menos de 24 horas.',
  contact_info_title: 'Información de Contacto',
  contact_phone_label: 'Teléfono',
  contact_email_label: 'Correo',
  contact_address_label: 'Oficina',
  contact_hours_label: 'Horario',
  contact_cta_title: '¿Necesitas Respuesta Rápida?',
  contact_cta_desc: 'Llámanos directamente para asistencia inmediata con tus necesidades de limpieza.',
  contact_call_now: 'Llamar Ahora',
  form_fullName: 'Nombre Completo',
  form_fullName_placeholder: 'Juan Pérez',
  form_phone: 'Teléfono',
  form_phone_placeholder: '(555) 000-0000',
  form_email: 'Correo',
  form_email_placeholder: 'juan@ejemplo.com',
  form_serviceType: 'Tipo de Servicio',
  form_serviceType_placeholder: 'Selecciona un servicio...',
  form_address: 'Dirección de la Propiedad',
  form_address_placeholder: '123 Calle Principal, Ciudad, CA',
  form_date: 'Fecha Preferida',
  form_message: 'Mensaje',
  form_message_placeholder: 'Cuéntanos más sobre tus necesidades de limpieza...',
  form_submit: 'Enviar Solicitud',
  form_required: 'Información Faltante',
  form_required_msg: 'Por favor completa todos los campos obligatorios (Nombre, Teléfono, Correo, Tipo de Servicio).',
  form_success: '¡Gracias por contactarnos!',
  form_success_body: 'Hello, please, you can call the number 7076236359 for an estimate. Thank you Hello, thank you for contacting complet care Home cleaning through this page. From which city are you contacting us? We work with counties Marin Napa Sonoma and Lake Kanyon we specialize in cleaning services, from deep cleaning to light cleaning in homes, offices, restaurants, and wynery bars. Can you send me the square feet of the property please. Thank you',
  form_error: 'Error',
  form_error_msg: 'Algo salió mal. Por favor intenta de nuevo.',

  // Footer
  footer_company: 'Complete Home Care Cleaning',
  footer_desc: 'Servicios profesionales de limpieza residencial y comercial en el área North Bay. Calidad en la que puedes confiar.',
  footer_links: 'Enlaces Rápidos',
  footer_areas: 'Áreas de Servicio',
  footer_social: 'Síguenos',
  footer_hours: 'Lun – Sáb: 8AM – 6PM',
  footer_copyright: '\u00a9 2026 Complete Home Care Cleaning. Todos los derechos reservados.',
  footer_made_with: 'Hecho con cuidado para hogares limpios.',

  // Admin
  admin_dashboard: 'Panel',
  admin_hero_slider: 'Slider Principal',
  admin_services: 'Servicios',
  admin_gallery: 'Galería',
  admin_service_areas: 'Áreas de Servicio',
  admin_page_content: 'Contenido de Página',
  admin_facebook: 'Feed de Facebook',
  admin_messages: 'Mensajes',
  admin_settings: 'Configuración',
  admin_website_admin: 'Administrador del Sitio',
  admin_complete_home: 'Complete Home Care',
  admin_manage: 'Gestionar',
  admin_system: 'Sistema',
  admin_back_website: 'Volver al sitio',
  admin_administrator: 'Administrador',
  admin_total_services: 'Total de Servicios',
  admin_gallery_images: 'Imágenes de Galería',
  admin_service_areas_short: 'Áreas de Servicio',
  admin_new_messages: 'Mensajes Nuevos',
  admin_new_quotes: 'Nuevas Cotizaciones',
  admin_new_appointments: 'Nuevas Citas',
  admin_new_ai_leads: 'Leads de IA',
  admin_active_services: 'Servicios activos',
  admin_in_portfolio: 'En portafolio',
  admin_coverage_zones: 'Zonas de cobertura',
  admin_pending_replies: 'Respuestas pendientes',
  admin_pending_quotes: 'Cotizaciones pendientes',
  admin_pending_appointments: 'Citas pendientes',
  admin_pending_ai_leads: 'Leads del asistente de IA',
  admin_edit_hero: 'Editar Hero',
  admin_update_slider: 'Actualizar imágenes y texto del slider',
  admin_add_service: 'Agregar Servicio',
  admin_create_service: 'Crear nueva oferta de servicio',
  admin_upload_image: 'Subir Imagen',
  admin_add_gallery: 'Agregar al portafolio de galería',
  admin_view_messages: 'Ver Mensajes',
  admin_check_quotes: 'Revisar solicitudes de cotización',
  admin_recent_messages: 'Mensajes Recientes',
  admin_recent_activity: 'Actividad Reciente',
  admin_view_all: 'Ver Todos',
  admin_backend_notice: 'Backend No Conectado',
  admin_backend_desc: 'La conexión API se activará después de integrar PHP/MySQL.',
  admin_saved: 'Guardado correctamente',
  admin_saved_local: 'guardado exitosamente (solo local — se necesita backend para persistencia).',
  admin_delete: 'Eliminar',
  admin_delete_confirm: 'Esta acción no se puede deshacer.',
  admin_deleted: 'Eliminado',
  admin_deleted_local: 'eliminado (solo local).',
  admin_cancel: 'Cancelar',
  admin_save_changes: 'Guardar Cambios',
  admin_add: 'Agregar',
  admin_edit: 'Editar',
  admin_close: 'Cerrar',
  admin_coming_soon: 'Próximamente',
  admin_requires_backend: 'Esta función requiere integración con backend.',
  admin_upload_image_title: 'Subir Imagen',
  admin_upload_backend: 'La subida de imágenes requiere integración con backend.',
  admin_active: 'Activo',
  admin_inactive: 'Inactivo',
  admin_visible: 'Visible en el sitio web',
  admin_hidden: 'Oculto del sitio web',
  admin_changes_local: 'Los cambios se guardan solo localmente',
  admin_field_saved: 'Campo Guardado',
  admin_content_updated: 'Contenido actualizado exitosamente.',
  admin_all_saved: 'Todos los Cambios Guardados',
  admin_reset_confirm: 'Esto revertirá todos los campos a sus valores predeterminados.',
  admin_reset_complete: 'Restablecimiento Completado',
  admin_settings_saved: 'Configuración Guardada',
  admin_business_info: 'Información del Negocio',
  admin_social_media: 'Enlaces de Redes Sociales',
  admin_business_hours: 'Horario de Atención',
  admin_company_name: 'Nombre de la Empresa',
  admin_phone_number: 'Número de Teléfono',
  admin_email_address: 'Correo Electrónico',
  admin_business_address: 'Dirección del Negocio',
  admin_facebook_url: 'URL de Facebook',
  admin_instagram_url: 'URL de Instagram',
  admin_yelp_url: 'URL de Yelp',
  admin_weekday_hours: 'Horario entre Semana',
  admin_weekend_hours: 'Horario de Fin de Semana',
  admin_timezone: 'Zona Horaria',
  admin_tip: 'Consejo',
  admin_settings_tip: 'Estas configuraciones se mostrarán en el pie de página y la sección de contacto de tu sitio web público.',
  admin_hero_manager: 'Gestor de Slider Principal',
  admin_manage_hero: 'Administra el contenido, servicios, galería y mensajes del sitio.',
  admin_add_slide: 'Agregar Slide',
  admin_slide_tag: 'Etiqueta',
  admin_slide_order: 'Orden de Visualización',
  admin_slide_title: 'Título del Slide',
  admin_slide_subtitle: 'Subtítulo / Descripción',
  admin_primary_btn: 'Texto del Botón Principal',
  admin_secondary_btn: 'Texto del Botón Secundario',
  admin_save_slide: 'Guardar Slide',
  admin_preview_image: 'Imagen de Vista Previa',
  admin_change_image: 'Cambiar Imagen',
  admin_services_manager: 'Gestor de Servicios',
  admin_manage_services: 'Administra tus ofertas de servicio',
  admin_add_service_btn: 'Agregar Servicio',
  admin_service_title: 'Título del Servicio',
  admin_short_desc: 'Descripción Corta',
  admin_full_desc: 'Descripción Completa',
  admin_shown_cards: 'Se muestra en tarjetas y listados de servicios',
  admin_shown_detail: 'Se muestra en vistas de detalle de servicios',
  admin_save_service: 'Guardar Servicio',
  admin_icon: 'Ícono',
  admin_gallery_manager: 'Gestor de Galería',
  admin_manage_gallery: 'Administra las imágenes de tu portafolio',
  admin_add_image: 'Agregar Imagen',
  admin_image_title: 'Título de la Imagen',
  admin_category: 'Categoría',
  admin_alt_text: 'Texto Alternativo',
  admin_alt_hint: 'Usado para lectores de pantalla y SEO',
  admin_save_image: 'Guardar Imagen',
  admin_areas_manager: 'Gestor de Áreas de Servicio',
  admin_manage_areas: 'Administra tus áreas de cobertura y ubicaciones',
  admin_add_area: 'Agregar Área',
  admin_city_name: 'Nombre de Ciudad / Área',
  admin_state: 'Estado',
  admin_display_order: 'Orden de Visualización',
  admin_area_updated: 'Área Actualizada',
  admin_area_added: 'Área Agregada',
  admin_area_saved: 'ha sido guardada (solo local).',
  admin_remove_area: '¿Estás seguro de que deseas eliminar',
  admin_content_manager: 'Gestor de Contenido de Página',
  admin_edit_content: 'Edita el texto de tu sitio web, información de contacto y mensajes clave',
  admin_unsaved: 'Cambios sin guardar',
  admin_save_all: 'Guardar Todos los Cambios',
  admin_reset_defaults: 'Restablecer a Valores Predeterminados',
  admin_content_hint: 'Mostrado en encabezado, pie de página y meta tags.',
  admin_phone_hint: 'Mostrado en encabezado, sección de contacto y pie de página.',
  admin_email_hint: 'Correo de contacto mostrado en el sitio web.',
  admin_hero_cta_hint: 'Texto del botón principal en el slider.',
  admin_about_title_hint: 'Encabezado mostrado arriba de la sección sobre nosotros.',
  admin_about_text_hint: 'Párrafo principal mostrado en la sección sobre nosotros.',
  admin_footer_hint: 'Texto corto mostrado en el pie de página arriba del copyright.',
  admin_facebook_settings: 'Configuración de Feed de Facebook',
  admin_facebook_desc: 'Configura la integración de tu página de Facebook y la visualización del feed',
  admin_facebook_url: 'URL de Página de Facebook',
  admin_embed_code: 'Código de Inserción del Feed de Facebook',
  admin_embed_hint: 'Pega el código de inserción del Plugin de Página de Facebook.',
  admin_facebook_help: 'Cómo obtener tu código de inserción',
  admin_facebook_help_desc: 'Visita Facebook Page Plugin para generar tu código de inserción.',
  admin_contact_messages: 'Mensajes de Contacto',
  admin_view_manage: 'Ver y gestionar solicitudes de cotización entrantes',
  admin_new_count: 'Nuevo',
  admin_contacted_count: 'Contactado',
  admin_resolved_count: 'Resuelto',
  admin_name: 'Nombre',
  admin_phone: 'Teléfono',
  admin_email: 'Correo',
  admin_service_type: 'Tipo de Servicio',
  admin_preferred_date: 'Fecha Preferida',
  admin_status: 'Estado',
  admin_created_at: 'Creado',
  admin_actions: 'Acciones',
  admin_no_messages: 'No se encontraron mensajes',
  admin_property_address: 'Dirección de la Propiedad',
  admin_received: 'Recibido',
  admin_send_email: 'Enviar Correo',
  admin_send_whatsapp: 'Enviar WhatsApp',
  admin_mark_contacted: 'Marcar como Contactado',
  admin_mark_resolved: 'Marcar como Resuelto',
  admin_archive: 'Archivar',
  admin_archived: 'Archivado',
  admin_archive_confirm: '¿Estás seguro de que deseas archivar este mensaje? Será removido de la lista activa.',
  admin_status_update_error: 'No se pudo actualizar el estado. Por favor intenta de nuevo.',
  admin_archive_error: 'No se pudo archivar. Por favor intenta de nuevo.',
  admin_status_updated: 'Estado cambiado a',
  admin_no_content: 'Sin contenido',
  admin_of_active: 'activas',
  admin_status_new: 'Nuevo',
  admin_status_contacted: 'Contactado',
  admin_status_resolved: 'Resuelto',
  admin_status_reviewing: 'En Revisión',
  admin_status_quoted: 'Cotizado',
  admin_status_won: 'Ganado',
  admin_status_lost: 'Perdido',
  admin_status_archived: 'Archivado',
  admin_status_scheduled: 'Agendado',
  admin_status_completed: 'Completado',
  admin_status_cancelled: 'Cancelado',
  admin_preferred_time: 'Hora Preferida',
  admin_no_contacted_messages: 'No hay mensajes contactados.',
  admin_activity_messages: 'Mensaje de Contacto',
  admin_activity_quotes: 'Solicitud de Cotización',
  admin_activity_appointments: 'Cita',
  admin_activity_ai_leads: 'Lead de IA',
  admin_activity_empty: 'Sin actividad reciente',
  admin_loading_dashboard: 'Cargando panel...',
  admin_dashboard_refresh: 'Actualizar Panel',
  admin_email_note: 'Esto abrirá tu cliente de correo predeterminado.',
  admin_whatsapp_body: 'Abrir chat de WhatsApp con',
  admin_whatsapp_note: 'Teléfono:',
  admin_marked_contacted: 'marcado como contactado',
  admin_marked_resolved: 'marcado como resuelto',

  // Form
  form_sending: 'Enviando...',
  form_thanks: '\u00a1Excelente, gracias!',

  // Detailed Quote Modal
  quote_cta: 'Obtener Cotizaci\u00f3n Detallada',
  quote_modal_title: 'Obt\u00e9n Tu Cotizaci\u00f3n Detallada',
  quote_modal_subtitle: 'Cu\u00e9ntanos sobre tu propiedad y te enviaremos una estimaci\u00f3n personalizada en menos de 24 horas.',
  quote_fullName: 'Nombre Completo',
  quote_fullName_placeholder: 'Juan P\u00e9rez',
  quote_phone: 'Tel\u00e9fono',
  quote_phone_placeholder: '(555) 000-0000',
  quote_email: 'Correo',
  quote_email_placeholder: 'juan@ejemplo.com',
  quote_address: 'Direcci\u00f3n de la Propiedad',
  quote_address_placeholder: '123 Calle Principal, Ciudad, CA',
  quote_propertyType: 'Tipo de Propiedad',
  quote_propertyType_placeholder: 'Selecciona tipo de propiedad...',
  quote_propertyType_house: 'Casa',
  quote_propertyType_apartment: 'Apartamento',
  quote_propertyType_office: 'Oficina',
  quote_propertyType_commercial: 'Comercial',
  quote_propertyType_post_construction: 'Post-Construcci\u00f3n',
  quote_propertyType_move_in_out: 'Entrada / Salida',
  quote_propertyType_other: 'Otro',
  quote_bedrooms: 'Dormitorios',
  quote_bedrooms_placeholder: 'p. ej., 3',
  quote_bathrooms: 'Ba\u00f1os',
  quote_bathrooms_placeholder: 'p. ej., 2',
  quote_kitchens: 'Cocinas',
  quote_kitchens_placeholder: 'p. ej., 1',
  quote_livingRooms: 'Salas',
  quote_livingRooms_placeholder: 'p. ej., 1',
  quote_diningRooms: 'Comedores',
  quote_diningRooms_placeholder: 'p. ej., 1',
  quote_offices: 'Oficinas',
  quote_offices_placeholder: 'p. ej., 0',
  quote_garage: 'Garaje',
  quote_garage_none: 'Ninguno',
  quote_garage_1: '1 Carro',
  quote_garage_2: '2 Carros',
  quote_garage_3plus: '3+ Carros',
  quote_garage_other: 'Otro',
  quote_squareFeet: 'Pies Cuadrados',
  quote_squareFeet_placeholder: 'p. ej., 2,500',
  quote_frequency: 'Frecuencia de Limpieza',
  quote_frequency_placeholder: 'Selecciona frecuencia...',
  quote_frequency_onetime: 'Puntual',
  quote_frequency_weekly: 'Semanal',
  quote_frequency_biweekly: 'Quincenal',
  quote_frequency_monthly: 'Mensual',
  quote_frequency_contract: 'Contrato',
  quote_frequency_event: 'Evento',
  quote_frequency_other: 'Otro',
  quote_cleaningType: 'Tipo de Limpieza',
  quote_cleaningType_placeholder: 'Selecciona tipo de limpieza...',
  quote_cleaningType_standard: 'Est\u00e1ndar',
  quote_cleaningType_deep: 'Limpieza Profunda',
  quote_cleaningType_post_construction: 'Post-Construcci\u00f3n',
  quote_cleaningType_move_in_out: 'Entrada / Salida',
  quote_cleaningType_office: 'Oficina',
  quote_cleaningType_event: 'Evento',
  quote_cleaningType_other: 'Otro',
  quote_extras: 'Extras',
  quote_extras_windows: 'Ventanas',
  quote_extras_oven: 'Horno Interior',
  quote_extras_fridge: 'Refrigerador Interior',
  quote_extras_cabinets: 'Gabinetes',
  quote_extras_baseboards: 'Z\u00f3calos',
  quote_extras_laundry: 'Lavander\u00eda',
  quote_extras_dishes: 'Platos',
  quote_extras_carpet: 'Aspirar Alfombras',
  quote_extras_garage: 'Limpieza de Garaje',
  quote_extras_patio: 'Patio',
  quote_date: 'Fecha Preferida',
  quote_time: 'Hora Preferida',
  quote_time_placeholder: 'p. ej., 10:00 AM',
  quote_budget: 'Rango de Presupuesto',
  quote_budget_placeholder: 'p. ej., $150 \u2013 $300',
  quote_notes: 'Notas',
  quote_notes_placeholder: 'Cualquier detalle adicional...',
  quote_notes_max: 'caracteres',
  quote_submit: 'Enviar Solicitud de Cotizaci\u00f3n',
  quote_submitting: 'Enviando...',
  quote_required: 'Informaci\u00f3n Faltante',
  quote_required_msg: 'Por favor completa todos los campos obligatorios (Nombre, Tel\u00e9fono, Correo, Tipo de Propiedad).',
  quote_city: 'Ciudad',
  quote_city_placeholder: 'p. ej., Santa Rosa',
  quote_success: '¡Gracias por contactarnos!',
  quote_success_body: 'Hello, please, you can call the number 7076236359 for an estimate. Thank you Hello, thank you for contacting complet care Home cleaning through this page. From which city are you contacting us? We work with counties Marin Napa Sonoma and Lake Kanyon we specialize in cleaning services, from deep cleaning to light cleaning in homes, offices, restaurants, and wynery bars. Can you send me the square feet of the property please. Thank you',

  quote_error: 'Error',
  quote_error_msg: 'Algo sali\u00f3 mal. Por favor intenta de nuevo.',
  quote_close: 'Cerrar',

  // AI Booking Widget
  ai_widget_btn: '¿Necesitas agendar una cita?',
  ai_widget_title: 'Asistente de Agendamiento',
  ai_widget_subtitle: 'Te ayudamos a reservar la cita perfecta',
  ai_tooltip: '¿Necesitas agendar?',
  ai_welcome_msg: 'Hello, please, you can call the number 7076236359 for an estimate. Thank you Hello, thank you for contacting complet care Home cleaning through this page. From which city are you contacting us? We work with counties Marin Napa Sonoma and Lake Kanyon we specialize in cleaning services, from deep cleaning to light cleaning in homes, offices, restaurants, and wynery bars. Can you send me the square feet of the property please. Thank you',
  ai_step1_msg: '¿Prefieres llamada telefónica o estimado presencial?',
  ai_phone_call: 'Llamada Telefónica',
  ai_in_person: 'Estimado Presencial',
  ai_step2_phone_msg: 'Por favor déjanos tu nombre, número de teléfono, fecha y hora preferida, y tipo de servicio. Te llamaremos para darte un estimado.',
  ai_step2_inperson_msg: 'Por favor déjanos tu nombre, número de teléfono, dirección de la propiedad, fecha y hora preferida, y tipo de servicio. Nos comunicaremos contigo para confirmar tu estimado presencial.',
  ai_step2_msg: 'Por favor déjanos tu nombre, número de teléfono, fecha y hora preferida, y tipo de servicio. Te llamaremos para darte un estimado.',
  ai_fullName: 'Nombre Completo',
  ai_fullName_placeholder: 'Juan Pérez',
  ai_phone: 'Teléfono',
  ai_phone_placeholder: '(555) 000-0000',
  ai_email: 'Correo',
  ai_email_placeholder: 'juan@ejemplo.com',
  ai_serviceType: 'Tipo de Servicio',
  ai_serviceType_placeholder: 'Selecciona un servicio...',
  ai_propertyAddress: 'Dirección de la Propiedad',
  ai_propertyAddress_placeholder: '123 Calle Principal, Ciudad, CA',
  ai_step3_msg: '¿Cuándo prefieres que pasemos?',
  ai_preferredDate: 'Fecha Preferida',
  ai_preferredTime: 'Hora Preferida',
  ai_preferredTime_placeholder: 'p. ej., 10:00 AM',
  ai_notes: 'Notas Adicionales',
  ai_notes_placeholder: 'Alguna instrucción especial...',
  ai_back: 'Atrás',
  ai_continue: 'Continuar',
  ai_schedule: 'Agendar Cita',
  ai_typing: 'escribiendo...',
  ai_success: '¡Gracias por contactarnos!',
  ai_success_body: 'Thank you. We received your request. We will contact you soon. For faster service, call (707) 623-6359.',
  ai_required_msg: 'Por favor completa todos los campos obligatorios: Nombre, Teléfono y Tipo de Servicio.',
  ai_required_address_msg: 'Por favor ingresa la dirección de la propiedad para el estimado presencial.',
  ai_error: 'Algo salió mal',
  ai_error_body: 'Por favor intenta de nuevo o llámanos directamente.',

  // Admin entities
  admin_slide: 'Slide',
  admin_image: 'Imagen',
  admin_service: 'Servicio',
  admin_saving: 'Guardando...',
  admin_missing_info: 'Información Faltante',
  admin_enter_city: 'Por favor ingresa el nombre de la ciudad o área.',
  admin_enter_state: 'Por favor ingresa la abreviatura del estado.',
  admin_missing_url: 'URL Faltante',
  admin_enter_facebook_url: 'Por favor ingresa la URL de tu página de Facebook.',
  admin_open_email_app: 'Abrir Correo',
  admin_open_whatsapp: 'Abrir WhatsApp',
  admin_saved_btn: '¡Guardado!',
  admin_total_areas: 'Áreas Totales',
  admin_active_short: 'Activas',
  admin_inactive_short: 'Inactivas',
  admin_states: 'Estados',
  admin_no_images: 'Aún no hay imágenes',
  admin_upload_images_desc: 'Sube imágenes para construir tu galería.',
  admin_no_service_areas: 'Aún no hay áreas de servicio',
  admin_add_first_area: 'Agrega tu primera área de cobertura para comenzar.',
  admin_no_slides: 'Aún no hay slides hero',
  admin_add_first_slide: 'Agrega tu primer slide para mostrarlo en la sección hero de la página principal.',
  admin_all_filter: 'Todas',
  admin_incoming_messages: 'Los mensajes de contacto entrantes aparecerán aquí.',
  admin_no_new_messages: 'No hay mensajes nuevos.',
  admin_no_contacted_messages: 'No hay mensajes contactados.',

  // Admin Message Tabs
  admin_tab_contact: 'Mensajes de Contacto',
  admin_tab_quotes: 'Solicitudes de Cotización',
  admin_tab_appointments: 'Citas',
  admin_tab_ai_leads: 'Leads de IA',
  admin_loading: 'Cargando...',
  admin_empty: 'No se encontraron registros',
  admin_refresh: 'Actualizar',
  admin_no_quotes: 'No se encontraron solicitudes de cotización.',
  admin_no_appointments: 'No se encontraron citas.',
  admin_no_ai_leads: 'No se encontraron leads de IA.',
  admin_appointment_type: 'Tipo de Cita',
  admin_property_type: 'Tipo de Propiedad',
  admin_budget: 'Presupuesto',
  admin_extras: 'Extras',
  admin_square_feet: 'Pies Cuadrados',
  admin_bedrooms: 'Dormitorios',
  admin_bathrooms: 'Baños',
  admin_source: 'Fuente',
  admin_cleaning_type: 'Tipo de Limpieza',
  admin_frequency: 'Frecuencia',
  admin_kitchens: 'Cocinas',
  admin_living_rooms: 'Salas',
  admin_dining_rooms: 'Comedores',
  admin_offices: 'Oficinas',
  admin_garage: 'Garaje',
  admin_incoming_quotes: 'Las solicitudes de cotización entrantes aparecerán aquí.',
  admin_incoming_appointments: 'Las citas entrantes aparecerán aquí.',
  admin_incoming_ai_leads: 'Los leads del asistente de IA aparecerán aquí.',
  admin_ai_assistant: 'Asistente de IA',
  admin_no_resolved_messages: 'No hay mensajes resueltos.',
  admin_ok: 'Aceptar',
  admin_enter_title: 'Ingrese el título del slide',
  admin_enter_desc: 'Ingrese la descripción del slide',
  admin_enter_service_name: 'Ingrese el nombre del servicio',
  admin_enter_short_desc: 'Breve descripción para las tarjetas',
  admin_enter_full_desc: 'Descripción detallada para la página de detalle',
  admin_image_example: 'p. ej., Limpieza Profunda de Sala',
  admin_alt_placeholder: 'Texto descriptivo para accesibilidad',
  admin_placeholder_city: 'p. ej., Santa Rosa',
  admin_placeholder_facebook: 'https://facebook.com/tupagina',
  admin_placeholder_hero_cta: 'Cotiza Gratis',
  admin_placeholder_about_title: 'Sobre Nosotros',
  admin_placeholder_about_text: 'Describe tu negocio...',
  admin_placeholder_footer_text: 'Tu eslogan del pie de página...',
  admin_placeholder_company: 'Nombre de la empresa',
  admin_placeholder_phone: '(555) 000-0000',
  admin_placeholder_email: 'contacto@empresa.com',
  admin_placeholder_address: 'Ciudad, Estado',
  admin_placeholder_fb_url: 'https://facebook.com/tupagina',
  admin_placeholder_ig_url: 'https://instagram.com/tuusuario',
  admin_placeholder_yelp_url: 'https://yelp.com/biz/tu-negocio',
  admin_placeholder_weekday: 'Lun–Vie: 8:00 AM – 6:00 PM',
  admin_placeholder_weekend: 'Sáb–Dom: 9:00 AM – 4:00 PM',
  admin_embed_placeholder: 'Pega tu código de inserción de Facebook aquí...',
  admin_tag_placeholder: 'SERVICIO PROFESIONAL',
  admin_category_house_cleaning: 'Limpieza de Casa',
  admin_category_apartment_cleaning: 'Limpieza de Apartamento',
  admin_category_office_cleaning: 'Limpieza de Oficina',
  admin_category_post_construction: 'Post-Construcción',
  admin_category_move_in_out: 'Entrada / Salida',
  admin_placeholder_city_name: 'p. ej., Santa Rosa',
  admin_placeholder_state: 'CA',

  // Admin Login
  admin_login_title: 'Acceso de Administrador',
  admin_login_email: 'Correo',
  admin_login_email_placeholder: 'admin@empresa.com',
  admin_login_password: 'Contraseña',
  admin_login_password_placeholder: 'Ingresa tu contraseña',
  admin_login_show_password: 'Mostrar contraseña',
  admin_login_hide_password: 'Ocultar contraseña',
  admin_login_captcha: 'Verificación de Seguridad',
  admin_login_captcha_question: '¿Cuánto es {{a}} + {{b}}?',
  admin_login_captcha_error: 'Respuesta incorrecta. Por favor intenta de nuevo.',
  admin_login_slider_hint: 'Desliza para verificar',
  admin_login_slider_success: 'Verificado',
  admin_login_slider_error: 'Intenta de nuevo',
  admin_login_submit: 'Iniciar Sesión',
  admin_login_loading: 'Ingresando...',
  admin_login_invalid: 'Correo o contraseña incorrectos.',
  admin_login_error: 'Error al iniciar sesión. Por favor intenta de nuevo.',
  admin_login_access_denied: 'Acceso Denegado',
  admin_login_access_denied_msg: 'Debes iniciar sesión para acceder al panel de administración.',
  admin_logout: 'Cerrar Sesión',
  admin_logout_confirm: '¿Estás seguro de que deseas cerrar sesión?',
  admin_logout_success: 'Sesión cerrada correctamente.',
  admin_back_to_site: 'Volver al Sitio',
  admin_change_password: 'Cambiar Contraseña',
  admin_current_password: 'Contraseña actual',
  admin_new_password: 'Nueva contraseña',
  admin_confirm_password: 'Confirmar nueva contraseña',
  admin_password_min_error: 'La contraseña debe tener al menos 8 caracteres.',
  admin_password_match_error: 'Las contraseñas no coinciden.',
  admin_password_required: 'Por favor completa todos los campos de contraseña.',
  admin_password_update: 'Actualizar Contraseña',
  admin_password_endpoint_error: 'El endpoint para cambiar contraseña no está disponible aún.',
  admin_password_success: 'Contraseña actualizada correctamente.',
  admin_api_error: 'Error de API. Por favor intenta de nuevo.',
  admin_api_saved: 'Guardado exitosamente.',
  admin_api_deleted: 'Eliminado exitosamente.',
  admin_loading_data: 'Cargando...',
  admin_add_success: 'Agregado exitosamente.',
  admin_upload_success: 'Imagen subida exitosamente.',
  admin_upload_error: 'Error al subir la imagen. Por favor intenta de nuevo.',
  admin_error: 'Error',
  admin_load_error: 'Error al cargar la configuración. Por favor intenta de nuevo.',
  admin_save_error: 'Error al guardar la configuración. Por favor intenta de nuevo.',
  admin_email_body: 'Enviar un correo a',
  admin_form_title: 'Título',
  admin_form_subtitle: 'Subtítulo',
  admin_form_description: 'Descripción',
  admin_form_image: 'Imagen',
  admin_form_upload: 'Subir Imagen',
  admin_form_order: 'Orden',
  admin_form_active: 'Activo',
  admin_form_save: 'Guardar',
  admin_form_cancel: 'Cancelar',
  admin_form_edit: 'Editar',
  admin_form_delete: 'Eliminar',
  admin_form_view: 'Ver',
  admin_form_mark_contacted: 'Marcar como Contactado',
  admin_toggle_menu: 'Mostrar/Ocultar menú',
  admin_prev_slide: 'Slide anterior',
  admin_next_slide: 'Slide siguiente',
  admin_go_slide: 'Ir al slide',
  admin_close_lightbox: 'Cerrar lightbox',
  admin_prev_image: 'Imagen anterior',
  admin_next_image: 'Imagen siguiente',
  service_recurring_contract: 'Contrato Recurrente',
  service_one_time_cleaning: 'Limpieza Puntual',
  service_deep_cleaning: 'Deep Cleaning',
  service_regular_cleaning: 'Regular Cleaning',
  service_light_cleaning: 'Light Cleaning',
  service_airbnb_cabin: 'Airbnb Cabin Cleaning',
};

export default homeTranslations;